import { Button } from '@progress/kendo-react-buttons'
import { DateRangePicker } from '@progress/kendo-react-dateinputs'
import over from 'lodash/fp/over'
import pipe from 'lodash/fp/pipe'
import isNil from 'lodash/isNil'
import moment from 'moment'
import * as React from 'react'
import {connect} from 'react-redux'
import { Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { FlashMessage } from '../../../components/flash-message'
import * as Form from '../../../components/form'
import { Loading } from '../../../components/loading'
import * as RasaInput from '../../../components/rasa-input'
import {ApplicationState} from '../../../rootReducer'
import * as Utils from '../../../utils'
import * as CommunityConfig from '../../community-config'
import * as Actions from './actions'
import * as Constants from './constants'
import { PartnerCode } from './partner-code'
import * as Types from './types'

interface DispatchProps {
  closeModal: any
  onSubmit: any
  postLeadText: Actions.PostLeadText
  resetForm: any
  updateDate: any
  updateField: any
}
interface Props extends DispatchProps {
  communityConfig: CommunityConfig.State,
  rawModal: Types.ModalState
  form: Types.FormState
}
export const RawEditModalComponent: React.SFC<Props> =
  ({communityConfig, rawModal, closeModal, form, updateDate, updateField, onSubmit}) =>
  <Modal isOpen={rawModal.isOpen && form.fields.type === Constants.RAW_EDITOR} className="lead-text-modal">
    <ModalHeader toggle={closeModal}>
      Raw HTML Lead Text
    </ModalHeader>
    <ModalBody>
      <FlashMessage />
      <PartnerCode partnerCodes={communityConfig.partnerCodes}
                    form={form}
                    updateField={updateField} />
      <div className="field">
        <Label className="field-label">Date Range</Label>
        <DateRangePicker
          value={{
            end: isNil(form.fields[Constants.FieldNames.EndDate]) ? null :
              form.fields[Constants.FieldNames.EndDate].toDate(),
            start: isNil(form.fields[Constants.FieldNames.StartDate]) ? null :
              form.fields[Constants.FieldNames.StartDate].toDate(),
          }}
          onChange={updateDate} />
      </div>
      <div className="field">
        <RasaInput.RasaInput label="Text"
          type="textarea"
          required
          value={form.fields.description || ''}
          validation={
            Constants.FormValidators[Constants.FieldNames.Description](
              form.fields[Constants.FieldNames.Description],
            )
          }
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            updateField({ name: Constants.FieldNames.Description, value: e.target.value })} />
      </div>
      <div className="field">
        <Label className="field-label">Preview Area</Label>
        <div className="lead-text-preview"
          dangerouslySetInnerHTML={{ __html: form.fields[Constants.FieldNames.Description] }} />
      </div>
    </ModalBody>
    <ModalFooter>
      {form.isSaving && <Loading size={Loading.Sizes.SMALL} />}
      <Button onClick={onSubmit} primary look="outline" disabled={
        form.isSaving || !form.isValid || isNil(form.fields.end_date) || isNil(form.fields.start_date) }>
        Save
      </Button>
      <Button look="outline" onClick={closeModal}>Cancel</Button>
    </ModalFooter>
  </Modal>

export const RawAddEditModal = connect(
  ({ leadText, communityConfig }: ApplicationState) =>
  ({communityConfig, rawModal: leadText.modal, form: leadText.form}),
  {
    closeModal: Actions.closeModal,
    onSubmit: Actions.saveForm,
    postLeadText: Actions.postLeadText,
    resetForm: Actions.FormActions[Form.RESET],
    updateField: Actions.updateField,
  },
  (stateProps, dispatchProps) => ({
    ...stateProps,
    ...dispatchProps,
    closeModal: over([
      () => dispatchProps.closeModal(),
      () => dispatchProps.resetForm(),
    ]),
    updateDate: pipe(
      Utils.selectValue,
      over([
        (date) => dispatchProps.updateField({
          name: Constants.FieldNames.StartDate,
          value: moment(date.start),
        }),
        (date) => dispatchProps.updateField({
          name: Constants.FieldNames.EndDate,
          value: date.end ? moment(date.end) : null,
        }),
      ]),
    ),
  }),
)(RawEditModalComponent)



// WEBPACK FOOTER //
// ./src/pages/lead-text/add-edit-modal/raw-edit-modal.tsx